import { UButtonGroupComponent } from '@updater/angular-common';
import { BackToDashboardButtonComponent } from '../../common/directives/back-to-dashboard-button';
import template from './password.html';
import { actions, selectors } from '../../../state';

const ERROR_MESSAGE =
  'Sorry. Something went wrong updating your password. Please try again later.';

export default angular
  .module('app.account.password', [
    UButtonGroupComponent.name,
    BackToDashboardButtonComponent.name,
  ])
  .config($stateProvider =>
    $stateProvider.state('app.account.password', {
      url: '/password',
      views: {
        'accountContent@app.account': {
          template,
          controller: 'PasswordController as passwordCtrl',
        },
      },
      title: 'My Password',
      analytics: {
        page: 'Account Password',
      },
    })
  )
  .controller('PasswordController', function($scope, updStore) {
    'ngInject';
    const { connect, dispatch } = updStore;

    const disconnect = connect(mapStateToThis)(this);
    $scope.$on('$destroy', disconnect);

    const clearForm = () => {
      $scope.passwordForm.$setPristine();
      $scope.passwordForm.$submitted = false;
      this.user.password = null;
    };

    this.updatePassword = user => {
      const success = () => {
        dispatch(
          actions.message.success('Success! Your password has been updated!')
        );
        dispatch(actions.analytics.track('Updated Password'));
      };

      const error = error => {
        dispatch(actions.message.error(this.errorMessage || ERROR_MESSAGE));
        dispatch(
          actions.analytics.track('Tried To Update Password', this.errorPayload)
        );
      };

      dispatch(actions.user.singleton(this.userId).update(user))
        .then(success, error)
        .finally(clearForm);
    };
  });

function mapStateToThis(state) {
  const { isUpdate } = actions.user;

  return {
    userId: selectors.current.user(state).id(state),
    submitting: selectors.pending.match(isUpdate, state),
    errorMessage: selectors.error.message(isUpdate, state),
    errorPayload: selectors.error.payload(isUpdate, state),
  };
}
